import React from 'react';
import NumberFormat, { NumberFormatValues } from 'react-number-format';
import { useStyles } from './tenderSection.styles';

interface Props {
  brilliantVoucher: string;
  setBrilliantVoucher: (value: string) => void;
  brilliantValue: string;
  setBrilliantValue: (value: string) => void;
  isTotalTenderValueValid: (value: NumberFormatValues, tenderValue: string) => boolean;
}

export const AlleTender = (props: Props) => {
  const { brilliantVoucher, setBrilliantVoucher, brilliantValue, setBrilliantValue, isTotalTenderValueValid } = props;
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <div className={classes.title}>All&#x0113;</div>
      <input
        type="text"
        value={brilliantVoucher}
        onChange={(e) => setBrilliantVoucher(e.target.value)}
        placeholder="Code/Note"
        className={classes.input}
        style={{ marginRight: '20px' }}
      />
      <NumberFormat
        decimalScale={2}
        fixedDecimalScale
        autoComplete="off"
        placeholder="Amount"
        value={brilliantValue}
        onChange={(e) => {
          setBrilliantValue(e.target.value);
        }}
        isAllowed={(inputObj) => isTotalTenderValueValid(inputObj, brilliantValue)}
        className={classes.input}
        type="tel"
      />
    </div>
  );
};
